import React, { useState, useEffect } from "react";
import { intl } from "LocaleWrapper";

import { Button, Menu, MenuItem, Divider } from "@mui/material";
import { withStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StyledMenuItem = withStyles((theme) => ({
	root: {
		color: props => props.isSelected ? theme.palette?.success?.main : "inherit",
		fontWeight: props => props.isSelected ? "500" : "inherit",
		textTransform: "capitalize",
	},
}))(MenuItem);

const RefreshButton = ({ id, onRefresh }) => {

	const [ anchorEl, setAnchorEl ] = useState(null);
	const [ refreshInterval, setRefreshInterval ] = useState(null);
	const [ minutesToRefresh, setMinutesToRefresh ] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const hardRefresh = () => {
		handleClose();
		onRefresh();
	};

	const clearAndSetInterval = (minutes) => {
		handleClose();
		setRefreshInterval(clearInterval(refreshInterval));
		setMinutesToRefresh(minutes);
		createInterval(minutes);
	};

	const createInterval = (minutes) => {
		if (minutes) {
			const milliseconds = (minutes * 60) * 1000;
			setRefreshInterval(setInterval(() => onRefresh(), milliseconds));
			localStorage.setItem(`refreshButton_${id}`, minutes);
		} else {
			localStorage.removeItem(`refreshButton_${id}`);
		}
	};

	useEffect(() => {
		if (localStorage.getItem(`refreshButton_${id}`)) {
			clearAndSetInterval(Number(localStorage.getItem(`refreshButton_${id}`)));
		}
	}, []);

	const refreshLabel = intl.formatMessage({ id: "UPDATES_REFRESH" });
	const offLabel = intl.formatMessage({ id: "OFF" });
	const minuteShortLabel = intl.formatMessage({ id: "MINUTE_SHORT" });

	return (
		<React.Fragment>
			<Button variant="outlined" color="primary" size="small" aria-controls="refresh-button-menu" aria-haspopup="true" onClick={handleClick}>
				{`${refreshLabel} ${minutesToRefresh ? `(${minutesToRefresh} ${minuteShortLabel})` : `(${offLabel})`}`}
				<ExpandMoreIcon fontSize="small" />
			</Button>

			 <Menu id="refresh-button-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
				<MenuItem onClick={() => hardRefresh()} dense>{intl.formatMessage({ id: "REFRESH_NOW" })}</MenuItem>

				<Divider />

				<StyledMenuItem
					onClick={() => clearAndSetInterval(undefined)}
					isSelected={!minutesToRefresh}
					dense>
					{intl.formatMessage({ id: "OFF" })}
				</StyledMenuItem>

				<StyledMenuItem
					onClick={() => clearAndSetInterval(1)}
					isSelected={minutesToRefresh === 1}
					dense>
					{intl.formatMessage({ id: "PLANBOARD_ONE_MINUTE" })}
				</StyledMenuItem>

				<StyledMenuItem
					onClick={() => clearAndSetInterval(3)}
					isSelected={minutesToRefresh === 3}
					dense>
					{intl.formatMessage({ id: "PLANBOARD_THREE_MINUTES" })}
				</StyledMenuItem>

				<StyledMenuItem
					onClick={() => clearAndSetInterval(5)}
					isSelected={minutesToRefresh === 5}
					dense>
					{intl.formatMessage({ id: "PLANBOARD_FIVE_MINUTES" })}
				</StyledMenuItem>

				<StyledMenuItem
					onClick={() => clearAndSetInterval(10)}
					isSelected={minutesToRefresh === 10}
					dense>
					{intl.formatMessage({ id: "PLANBOARD_TEN_MINUTES" })}
				</StyledMenuItem>
			</Menu>
		</React.Fragment>
	);
};

export default RefreshButton;
